import React from "react";
import "./drawer.css";
import close_icon from "../../assets/icons/close.svg";
import { CSSTransition } from "react-transition-group";

const DrawerComponent = ({
  show,
  showDrawer,
  title,
  children,
  subtitle,
  paddingAllowed = true,
}) => {
  return (
    <>
      <CSSTransition in={show} unmountOnExit timeout={{ enter: 0, exit: 300 }}>
        <div
          className={`drawer fixed 
          inset-0 bg-[#344335] bg-opacity-50 z-20 opacity-0
           overflow-y-auto h-full w-full transition-all duration-[0.3s]`}
        >
          <div
            className={`drawer-content fixed z-40 top-0 -right-80 md:w-[500px] w-80 h-screen py-6 ${
              paddingAllowed ? "px-6" : ""
            } overflow-y-auto transition-all duration-[0.3s] bg-white`}
          >
            <div className="flex justify-between items-center pb-2">
              <div>
                <h5
                  className={`text-lg font-semibold text-[#5C715E] ${
                    !paddingAllowed && "px-6"
                  }`}
                >
                  {title}
                </h5>
                <h6
                  className={`text-sm font-medium text-[#5F6D60] ${
                    !paddingAllowed && "px-6"
                  }`}
                >
                  {subtitle}
                </h6>
              </div>
              <button
                type="button"
                onClick={() => showDrawer(false)}
                className={`text-gray-400 bg-[#EDF7EE]
                              py-4 px-6
                            rounded-lg text-sm flex items-center justify-center ${
                              !paddingAllowed && "mr-6"
                            }`}
              >
                <img src={close_icon} className="" alt="close icon" />
              </button>
            </div>

            {/* drawer body */}

            {children}
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default DrawerComponent;
